import React from 'react';
import clipImageOne from '../../../../assets/img/clips-imgs/clip-img1.png'; 
import clipsPlayImg from '../../../../assets/img/clips-imgs/clips-play.svg';
import clipSmileTwo from '../../../../assets/img/clips-imgs/clip-smallimg2.png';
import clipSmileOne from '../../../../assets/img/clips-imgs/clip-smallimg1.png';
import clipSmilePlay from '../../../../assets/img/clips-imgs/clip-smallplay.svg';
import clipSmileThree from '../../../../assets/img/clips-imgs/clip-smallimg3.png';

const FundraisersVideoSection = () => {
    return (
        <div className="col-12 col-lg-7 position-relative">
            <div className="row mb-3">
                <div className="col position-relative">
                    <img className="w-100 border-radius-image" src={clipImageOne} alt='' />
                    <div className="position-absolute c_play">
                        <img src={clipsPlayImg} alt='' />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                    <img className="w-100 border-radius-image-with-opacity" src={clipSmileTwo}  alt='' />
                </div>
                <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                    <div className="position-relative">
                        <img className="w-100 border-radius-image-with-border " src={clipSmileOne}  alt='' />
                        <div className="position-absolute c_play">
                            <img src={clipSmilePlay} alt='' />
                            </div>
                    </div>
                </div>
                <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                    <img className="w-100" src={clipSmileThree} alt='' />
                    </div>
                <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4"></div>
            </div>
        </div>
    );
};

export default FundraisersVideoSection;